import { useState } from 'react';
import { capitalizeFirstLetter } from '../../utilities/services/capitalizeFirstLetter';
import './ClientItemSummary.css';
import ClientFormsSummary from '../ClientFormsSummary/ClientFormsSummary';
import ClientProjectsSummary from '../ClientProjectsSummary/ClientProjectsSummary';
import ClientApplicationsSummary from '../ClientApplicationsSummary/ClientApplicationsSummary';

export default function ClientItemSummary({user, client, services, summaryData}) {    
    const tabs = {
        forms: 'Forms',
        projects: 'Projects',
        applications: 'Applications',
    }

    const [activeTabIndex, setActiveTabIndex] = useState(Object.keys(tabs)[0]);

    const handleTabClick = (tab) => {
        setActiveTabIndex(tab);
    }

    const handleDropdownClick = (evt) => {
        evt.stopPropagation()
    }

  return (
    <div className="ClientItemSummary modal fade" id={`clientItemSummaryModal`} data-bs-keyboard="true">
        <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content summaryContainer">
                <div className="modal-header">
                    <div className='left'>
                        <div className='first'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" fill="currentColor" className="bi bi-bookmark-check-fill" viewBox="0 0 16 16">
                                <path fillRule="evenodd" d="M2 15.5V2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.74.439L8 13.069l-5.26 2.87A.5.5 0 0 1 2 15.5m8.854-9.646a.5.5 0 0 0-.708-.708L7.5 7.793 6.354 6.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0z"/>
                            </svg>
                        </div>
                        <div className='second'>
                            <div className='sec1'>
                                {capitalizeFirstLetter(client.companyName)} Summary
                            </div>
                        </div>
                    </div>
                    <div className='right'>
                        <svg data-bs-dismiss="modal" width="20" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="16.2666" cy="16.2666" r="15.7666" fill="#EDEFF2" stroke="#EEEEEE"/>
                            <path d="M21.1093 12L12 21.1093M12 12L21.1093 21.1093" stroke="#1B2B41" strokeOpacity="0.8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                </div>
                <div className="modal-body">
                    <div className='summaryContentMainSection'>
                        <div className="nav nav-pills flex-row navigation" id="v-pills-tab" role='tablist' aria-orientation="horizontal">
                        {Object.keys(tabs).map((tab, index) => (
                            <button key={tab} onClick={() => handleTabClick(tab)} className={`nav-link ${activeTabIndex === tab ? 'active' : ''}`} id={`${tab}Tab`} type="button">
                                {tabs[tab]}
                            </button>
                        ))}
                        </div>
                        <div className="tab-content" id="v-pills-tabContent">
                            {Object.keys(tabs).map((tab, index) => (
                            <div key={tab} className={`tab-pane fade ${activeTabIndex === tab ? 'show active' : ''}`} id={`${tab}`} role="tabpanel" aria-labelledby={`${tab}Tab`}>
                                { (summaryData && user) &&
                                <>
                                {tab === 'forms' &&
                                <ClientFormsSummary client={client} formsData={summaryData.forms} services={services} handleDropdownClick={handleDropdownClick} />
                                }
                                {tab === 'projects' &&
                                <ClientProjectsSummary user={user} client={client} projectsData={summaryData.projects} services={services} handleDropdownClick={handleDropdownClick} />
                                }
                                {tab === 'applications' &&
                                <ClientApplicationsSummary user={user} client={client} applicationsData={summaryData.applications} services={services} handleDropdownClick={handleDropdownClick} />
                                }
                                </>
                                }
                            </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}
